import { compose } from 'redux'

import withPasswordValidation from './withPasswordValidation'

import UI from './UI'

export default compose(withPasswordValidation)(UI)

export { validatePasswordRequirements } from './validatePassword'
